
// import { PropsWithChildren } from "react"
import { ReactNode } from "react";
import { useTableContext } from "./TableContext";

const TableFooter = () => {
    const { tfoot, columns } = useTableContext();

    if (!tfoot) return null;

    let tFootContent: ReactNode = tfoot as ReactNode;

    if (typeof tfoot === 'function') {
        tFootContent = tfoot({ columns });
    }

    return (
        <tfoot>
            {tFootContent}
        </tfoot>
    )
}

export default TableFooter;